import React, { useEffect, useState } from 'react'
import { Row } from 'reactstrap';
import ObPfHoldingsBase from './ObPfHoldingsBase';

const LiquidationCard = (props) => {
  const [producttypes, setProductTypes] = useState([]);
  const {isMobile, requests} = props;
  
  useEffect(() => {
    let tmpproductypes = [];

    for (const item of requests) {
      const value = item.productType;
      if (!tmpproductypes.includes(value)) {
        tmpproductypes.push(value);
      }
    }
    setProductTypes([...tmpproductypes]);
  },[props])

  return !isMobile
    ? (producttypes &&
        producttypes.length) ?
        producttypes?.map((entry) => (
      requests.some(pt => pt.productType === entry) ?
          <Row className="liquidation-wrapper" key={entry}>
            <p className="font-weight-semi-bold header mb-3">
              {entry === "bonds"
                ? "Bonds"
                : entry === "mld"
                ? "Market Linked Debentures"
                : ""}
            </p>
            {requests?.map((item, index) => {
              if (item.productType === entry) {
                return (
                  <div key={item.orderId} className="liq-outer">
                    <ObPfHoldingsBase
                      title={props?.bondDetails?.filter((e) => e.product === item.product)[0]
                        ?.issuer}
                      img={
                        props?.bondDetails?.find(
                          (e) => e.product === item.product
                        )?.logoUrl
                      }
                      firstCard={true}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Units"
                      value={item?.amountBreakup?.units}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Redemption Amount"
                      value={item?.amountBreakup?.ispAmount ? (item?.amountBreakup?.ispAmount).oroNumber(2, true) : "--"}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Liquidation Status"
                      value={
                        item.currentState.state === "RA" || item.currentState.state === "SA"
                          ? "Pending"
                          : item.currentState.state === "RP"
                          ? "Completed"
                          : ""
                      }
                      index={index}
                      isMobile={isMobile}
                      infoText={"Lorem Ipsum text"}
                    />
                  </div>
                );
              }
              return null; // Return null for items that don't match the condition
            })}
          </Row> : null
        ))
        : <Row className='liquidation-wrapper'>
            <p className="font-weight-semi-bold header mb-3 text-center">
              No Pending requests
            </p>
        </Row>
    : 
    (producttypes &&
    producttypes.length) ?
    producttypes?.map((entry) => (
      requests.some(pt => pt.productType === entry) ?
        <Row className="liquidation-wrapper" key={entry}>
          <p className="font-weight-semi-bold header mb-3">
            {entry === "bonds"
                ? "Bonds"
                : entry === "mld"
                ? "Market Linked Debentures"
                : ""
            }
          </p>
          {requests?.map((item, index) => {
              if (item.productType === entry) {
                return (
          <div key={item.orderId} className="liq-outer">
            <ObPfHoldingsBase
              title={props?.bondDetails?.filter((e) => e.product === item.product)[0]
                ?.issuer}
              img={
                props?.bondDetails?.find(
                  (e) => e.product === item.product
                )?.logoUrl
              }
              firstCard={true}
              isMobile={isMobile}
            />

            <div className="hr"></div>

            <div className="wrapper">
              <ObPfHoldingsBase 
                title="Units" 
                value={item?.amountBreakup?.units} 
                isMobile={isMobile} />
              <ObPfHoldingsBase
                title="Redemption Amount"
                value={(item?.amountBreakup?.ispAmount).oroNumber(2, true)}
                isMobile={isMobile}
              />
              <ObPfHoldingsBase
                title="Liquidation Status"
                value={
                  item.currentState.state === "RA" || item.currentState.state === "SA"
                    ? "Pending"
                    : item.currentState.state === "RP"
                    ? "Completed"
                    : ""
                }
                isMobile={isMobile}
                infoText={"Lorem Ipsum text"}
                index={index}
              />
            </div>
            {/* <span className="view" onClick={() => redirectToProduct(item, props.holdings[item].productType)}>
                  View Details
                </span> */}
          </div>
                );
              }
              return null; // Return null for items that don't match the condition
            })}
        </Row> 
        : null
      ))
    :
    <Row className='liquidation-wrapper'>
        <p className="font-weight-semi-bold header mb-3 text-center">
          No Pending requests
        </p>
    </Row>
}

export default LiquidationCard